<template>
  <!-- <div>
    <img src="../../assets/images/jiemudan_bg.png" class="bg" alt />
    <img class="title" src="../../assets/images/jiemudan_title.png" alt />
    <div class="wrap">
      <div class="summary">
        <img src="../../assets/images/time.png" alt />
        <span class="key">时间</span>
        <span class="detail">：2019年8月17日(星期六)下午13:30</span>
      </div>
      <div class="summary">
        <img src="../../assets/images/location.png" alt />
        <span class="key">地点</span>
        <span class="detail">：上海儿童艺术剧场(苗江路800号)</span>
      </div>
      <div class="summary">
        <img src="../../assets/images/master.png" alt />
        <span class="key">主持人</span>
        <span class="detail">：高渊 贾伟婕 张洋 诸佳怡</span>
      </div>
    </div>
    <div class="wrap">
      <img src="../../assets/images/dot.png" alt class="dot dot-left" />
      <img src="../../assets/images/dot.png" alt class="dot dot-right" />

      <div class="section-title">序《建工抒豪情》</div>
      <div class="item">
        <div class="left">1.开场歌曲</div>
        <div class="name">《建工之歌》</div>
        <div class="unit">建工合唱团 全场合唱</div>
      </div>
      <div class="item">
        <div class="left">2.领导讲话</div>
      </div>

      <div class="section-title">第一篇章《铭记来时路》</div>
      <div class="item">
        <div class="left">3.合唱联唱</div>
        <div class="name">
          《中国，中国，鲜红的太阳永不落》
          <br />《不忘初心》
        </div>
        <div class="unit">全场合唱</div>
      </div>
      <div class="item">
        <div class="left">
          4.演讲
        </div>
        <div class="name">《上海建工品牌在红土地落地开花》</div>
        <div class="unit">二建集团</div>
      </div>
      <div class="item">
        <div class="left">5.合唱</div>
        <div class="name">《红军不怕远征难》</div>
        <div class="unit">集团本部</div>
      </div>
      <div class="item">
        <div class="left">6.合唱</div>
        <div class="name">《娄山关》</div>
        <div class="unit">材料公司</div>
      </div>
      <div class="item">
        <div class="left">7.合唱</div>
        <div class="name">《祖国不会忘记》</div>
        <div class="unit">基础公司</div>
      </div>
      <div class="item">
        <div class="left">8.演讲</div>
        <div class="name">《平凡的英雄》</div>
        <div class="unit">材料公司</div>
      </div>
      <div class="item">
        <div class="left">9.合唱</div>
        <div class="name">《当那一天来临》</div>
        <div class="unit">机施集团</div>
      </div>

      <div class="item">
        <div class="left">10.合唱</div>
        <div class="name">《大中国》</div>
        <div class="unit">七建集团</div>
      </div>

      <div class="item">
        <div class="left">11.演讲</div>
        <div class="name">《泥瓦工的"匠心"》</div>
        <div class="unit">园林集团</div>
      </div>

      <div class="item">
        <div class="left">12.合唱</div>
        <div class="name">《龙的传人》</div>
        <div class="unit">五建集团</div>
      </div>
      <div class="section-title">第二篇章《颂歌献祖国》</div>

      <div class="item">
        <div class="left">13.合唱</div>
        <div class="name">《在灿烂阳光下》</div>
        <div class="unit">市政总院</div>
      </div>
      <div class="item">
        <div class="left">14.合唱联唱</div>
        <div class="name">
          《我和我的祖国》
          <br />《外婆的澎湖湾》
        </div>
        <div class="unit">房产公司</div>
      </div>

      <div class="item">
        <div class="left">15.合唱</div>
        <div class="name">《祖国慈祥的母亲》</div>
        <div class="unit">外经集团</div>
      </div>

      <div class="item">
        <div class="left">16.合唱</div>
        <div class="name">《美丽中国》</div>
        <div class="unit">四建集团</div>
      </div>

      <div class="item">
        <div class="left">17.合唱</div>
        <div class="name">《今天是你的生日，我的祖国》</div>
        <div class="unit">建工医院</div>
      </div>

      <div class="item">
        <div class="left">18.合唱</div>
        <div class="name">《红旗飘飘》</div>
        <div class="unit">海外部</div>
      </div>

      <div class="section-title">第三篇章《逐梦新征程》</div>

      <div class="item">
        <div class="left">19.合唱联唱</div>
        <div class="name">
          《咱们工人有力量》
          <br />《建设者之歌》
          <br />《我们走在大路上》
        </div>
        <div class="unit">全场联唱</div>
      </div>
      <div class="item">
        <div class="left">20.演讲</div>
        <div class="name">《他们，“打印”了一座桥》</div>
        <div class="unit">机施集团</div>
      </div>

      <div class="item">
        <div class="left">21.合唱</div>
        <div class="name">
          《我的中国心》
          <br />《今日痛饮庆功酒》
        </div>
        <div class="unit">建工设计</div>
      </div>

      <div class="item">
        <div class="left">22.合唱</div>
        <div class="name">《中国梦想》</div>
        <div class="unit">安装集团</div>
      </div>
      <div class="item">
        <div class="left">23.合唱</div>
        <div class="name">《远方的客人请你留下来》</div>
        <div class="unit">园林集团</div>
      </div>

      <div class="item">
        <div class="left">24.演讲</div>
        <div class="name">《奔跑吧，建工人》</div>
        <div class="unit">总承包部</div>
      </div>

      <div class="item">
        <div class="left">25.合唱</div>
        <div class="name">《光荣与梦想》</div>
        <div class="unit">装饰集团</div>
      </div>
      <div class="item">
        <div class="left">26.演讲</div>
        <div class="name">《邂逅最美德清》</div>
        <div class="unit">五建集团</div>
      </div>
      <div class="item">
        <div class="left">27.合唱</div>
        <div class="name">《兴业路上的初心》</div>
        <div class="unit">二建集团</div>
      </div>
      
      <div class="item">
        <div class="left">28.合唱</div>
        <div class="name">《让世界都赞美你》</div>
        <div class="unit">总承包部</div>
      </div>

      <div class="section-title">尾声《昂首再出发》</div>

      <div class="item">
        <div class="left">29.合唱</div>
        <div class="name">《再一次出发》</div>
        <div class="unit">一建集团</div>
      </div>

      <div class="item">
        <div class="left">30.颁奖</div>
      </div>
      <div class="item">
        <div class="left">31.合唱</div>
        <div class="name">《我和我的祖国》</div>
        <div class="unit">全场合唱</div>
      </div>
    </div>
  </div> -->
  <div>
    <img src="../../assets/images/jiemudan.jpg" style="width:100%;" alt="">
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.title {
  width: 100%;
}
.summary {
  padding: 5px 0;
}
.summary img {
  width: 13px;
}
.summary span {
  font-size: 13px;
  color: #fc625b;
}
.summary .key {
  margin-left: 5px;
  width: 40px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}
.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  z-index: -1;
}
.wrap {
  background: white;
  border-radius: 5px;
  padding: 15px;
  margin: 15px;
  position: relative;
  box-shadow: 0px 0px 46px 0px rgba(198, 26, 19, 0.17);
}
.dot {
  position: absolute;
  top: -28px;
  width: 18px;
}
.dot-left {
  left: 20%;
}
.dot-right {
  right: 20%;
}
.section-title {
  padding: 5px;
  background: linear-gradient(
    0deg,
    rgba(250, 129, 82, 1),
    rgba(255, 187, 83, 1)
  );
  border-radius: 0px 25px 25px 0px;
  margin-left: -15px;
  color: white;
  display: inline-block;
}

.item {
  margin: 12px 0;
  font-size: 13px;
  vertical-align: top;
}
.item:before,
.item:after {
  display: table;
  content: " ";
}
.item:after {
  clear: both;
}

.item .left {
  display: inline-block;
  vertical-align: top;
}
.item .name {
  display: inline-block;
  vertical-align: top;
}
.item .unit {
  float: right;
  color: #d44437;
}
</style>